var $6acb056cb92f3dd4$exports = {};
$6acb056cb92f3dd4$exports = {
    "endTime": `Godzina ko\u{144}cowa`,
    "startTime": `Godzina pocz\u{105}tkowa`,
    "time": `Godzina`
};


export {$6acb056cb92f3dd4$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
